import React from 'react';
import { render } from 'react-dom';
import ErrorMessage from './errorMessage';

const centeredStyle = {
    display: 'block',
    margin: 'auto'
}

class Loader extends React.Component {
    render() {
        if (this.props.hasError) {
            return (
                <ErrorMessage />
            );
        } 
        return (
            <img
                style={centeredStyle}
                src={`${this.props.customLoader ? this.props.customLoader : "./images/ProgressIndicator/ajax-loader-big.gif"}`}
            />
        );
    }
}
export default Loader;  